/**
 * 401 navigation policy.
 * Dead sessions on public/sales pages must not dump visitors on login.
 * Only screens that cannot work without a session go to /login.
 */
const SESSION_REQUIRED_PREFIXES = [
  "/cms",
  "/add-new-post",
  "/edit-post",
  "/user-profile",
  "/admin",
];

export const isSessionRequiredPath = (pathname = "") => {
  const path = pathname || "/";
  return SESSION_REQUIRED_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
};

export const handleExpiredSession = () => {
  if (typeof window === "undefined") return;

  const { pathname, search, hash } = window.location;

  if (isSessionRequiredPath(pathname)) {
    window.location.href = "/login";
    return;
  }

  window.location.replace(`${pathname}${search}${hash}` || "/");
};
